module.exports = __webpack_public_path__ + "static/media/icon_add_self.5a788b40.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_add_self.png
// module id = 2159
// module chunks = 0